module.exports = __webpack_public_path__ + "img/av203.88df69b6.png";